// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__yfSfW","reset":"styles_reset__xuqYa"};